import _isNil from 'lodash/isNil';
import { teamEndPoints, userEndPoints } from '@Services/data/ApiHandler';
import store from '@Services/redux/Store';
import { ITeam } from './Interfaces';
import { TeamActions } from './Reducer';

const Api = {
    // getAllTeams: async (callback?: () => void) => {
    //     const response = await teamEndPoints.getAllTeams();

    //     if (response.isSuccess) {

    //         if (callback) {
    //             callback();
    //         }
    //     }
    // },
    getOrganizationTeams: async (
        organization_id,
        teamId?,
        callback?: () => void
    ) => {
        const response = await teamEndPoints.getOrganizationTeams(
            organization_id
        );
        if (response.isSuccess) {
            const teams: Array<ITeam> = response.data.teamDetails;
            const combined: Array<ITeam> = [];

            teams.forEach((team) => {
                const orgRel: any = team.relationship;
                const existingIndex = combined.findIndex(
                    (t) => t.team_id === team.team_id
                );
                if (existingIndex > -1) {
                    combined[existingIndex].relationship.push(orgRel);
                } else {
                    combined.push({ ...team, relationship: [orgRel] });
                }
            });

            store.dispatch(TeamActions.updateTeams(combined));

            if (teamId) {
                const foundTeam = combined.find((t) => t.team_id === teamId);
                console.log(foundTeam);
                if (!_isNil(foundTeam)) {
                    await Api.setSelectedTeam(foundTeam);
                }
            }

            if (callback) {
                callback();
            }
            return combined;
        }
    },
    setSelectedTeam: (team: ITeam) => {
        store.dispatch(TeamActions.setSelectedTeam(team));
    },
    setTeams: (teams: Array<ITeam>) => {
        store.dispatch(TeamActions.updateTeams(teams));
    },
    getAllUsers: async (callback?: () => void) => {
        // const response = await userEndPoints.getUsers();
        // if (response.isSuccess) {
        //     store.dispatch(TeamActions.updateUsers(response.data));
        //     if (callback) {
        //         callback();
        //     }
        // }
    },
    getTeamMembers: async (teamId: string, callback?: () => void) => {
        const response = await teamEndPoints.getTeamUsers(teamId);
        if (response.isSuccess) {
            store.dispatch(
                TeamActions.updateTeamMembers(response.data.userDetails)
            );
            if (callback) {
                callback();
            }
        }
    },
    getTeamMembersInDepartment: async (
        teamId: string,
        departmentId: string,
        callback?: () => void
    ) => {
        const response = await teamEndPoints.getTeamUsersInDepartment(
            teamId,
            departmentId
        );
        store.dispatch(
            TeamActions.updateTeamMembersInDepartment(response.data.userDetails)
        );
        if (response.isSuccess) {
            if (callback) {
                callback();
            }
        }
    },
    _createTeamRequestBody: (
        organizationId: string,
        teamName: string,
        ownerEmail: string,
        isActive: boolean
    ): object => {
        const output = {
            organisation_fk: organizationId,
            team_name: teamName,
            owner_email: ownerEmail,
            is_active: isActive,
        };
        return output;
    },
    createTeam: async (
        oganizationId: string,
        teamName: string,
        ownerEmail: string,
        isActive: boolean,
        callback?: () => void
    ) => {
        const body = Api._createTeamRequestBody(
            oganizationId,
            teamName,
            ownerEmail,
            isActive
        );

        const response = await teamEndPoints.createTeam(body);
        console.log(response);

        if (response.isSuccess) {
            if (callback) {
                callback();
            }
        }
    },
    _updateTeamRequestBody: (
        teamId: string,
        organizationId: string,
        teamName: string,
        teamLeaderEmail: string,
        isActive: boolean
    ): object => {
        const output = {
            team_id: teamId,
            organisation_fk: organizationId,
            team_name: teamName,
            team_leader_email: teamLeaderEmail,
            is_active: isActive,
        };
        return output;
    },
    updateTeam: async (
        teamId: string,
        organizationId: string,
        teamName: string,
        teamLeaderEmail: string,
        isActive: boolean,
        callback?: () => void
    ) => {
        const body = Api._updateTeamRequestBody(
            teamId,
            organizationId,
            teamName,
            teamLeaderEmail,
            isActive
        );

        const response = await teamEndPoints.updateTeam(body);

        if (response.isSuccess) {
            if (callback) {
                callback();
            }
            return response.data.teamDetails;
        }
    },
    _addMembersToTeamRequestBody: (
        teamId: string,
        userIds: Array<string>
    ): object => {
        const output = {
            team_id: teamId,
            user_ids: userIds,
        };
        return output;
    },
    addMembersToTeam: async (
        teamId: string,
        members: Array<string>,
        callback?: () => void
    ) => {
        const body = Api._addMembersToTeamRequestBody(teamId, members);
        console.log(body);
        const response = await teamEndPoints.createTeamUsers(body);

        if (response.isSuccess) {
            if (callback) {
                callback();
            }
        }
    },
    deleteTeamMember: async (
        teamId: string,
        userId: string,
        callback?: () => void
    ) => {
        const response = await teamEndPoints.deleteTeamUser(teamId, userId);

        if (response.isSuccess) {
            if (callback) {
                callback();
            }
        }
    },
    clearTeams: () => {
        store.dispatch(TeamActions.clearTeams());
    },
};

export default Api;
